import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import TableDetailsPop, {DetailItem} from '../../../../../../components/tableDetailsPop/TableDetailsPop';
import {TShow} from '../../../../../../../component/prompotionPopup/PromotionPopup';
import {SubscriptionPlan} from '../../../../../../../redux/subscription/subscription.type';
import {seriesTypeLabel} from '../../../../../../subscriptions/utils/subscriptionUtils';
import {defaultImage} from '../../../../../../../assets/symbols/images/defaultImage';
import {Label, Button, LinkButton} from '@tickchak/react-share/app';

function DetailsPop({plan, detailsPopShow, onCloseDetails}: {plan: SubscriptionPlan; detailsPopShow: TShow; onCloseDetails: () => void;}) {
    const {t} = useTranslation('realtime');
    const {eid} = useSelector((s: any) => s.event);
    
    const details: DetailItem[] = [
        {label: t('eventsInSeries'), value: plan.eventsCount || 0},
        {label: t('activeEvents'), value: plan.activeEventsCount || 0},
        {label: t('pastEvents'), value: plan.passedEventsCount || 0},
        {label: t('salesPerPlan'), value: (plan.amount - plan.amountAvailable) || 0},
        {label: t('remainingTickets'), value: plan.amountAvailable || 0},
        {label: t('realizations'), value: plan.realizations || 0},
    ];

    const subtitle = (
        <Label backgroundColor={seriesTypeLabel[plan.planType]?.color}>
            {t(seriesTypeLabel[plan.planType]?.label)}
        </Label>
    );

    const actions = (
        <>
            <LinkButton 
                variant="brand" 
                size="chip" 
                href={`/e/${eid}/subscription`}
                customStyle={{flex: 1}}
            >
                {t('seriesPage')}
            </LinkButton>
            <Button 
                variant="subtle" 
                size="chip" 
                onClick={onCloseDetails}
                customStyle={{flex: 1, backgroundColor: 'var(--primitive-black-05)'}}
            >
                {t('close')}
            </Button>
        </>
    );

    return (
        <>
            {detailsPopShow.isOpen && (
                <TableDetailsPop 
                    title={plan.title}
                    subtitle={subtitle}
                    image={plan.image?.path || defaultImage}
                    details={details}
                    actions={actions}
                    show={detailsPopShow}
                    onClose={onCloseDetails}
                    dataCyName="subscriptionDetails"
                />
            )}
        </>
    );
}

export default DetailsPop;

